import { Tab } from '@features/ui';
import { useMemo, useState } from 'react';
import { TTab } from '@src/types';
import {
  PackageContent,
  DisplayOptions,
  PayoutLogic,
  Financials,
} from '@features/admin/packages';

export const PackagesEditPage = () => {
  const [tabActive, setTabActive] = useState(0);

  const tabs = useMemo(
    (): TTab[] => [
      { label: 'Package Content', component: <PackageContent /> },
      { label: 'Display Options', component: <DisplayOptions /> },
      { label: 'Financials', component: <Financials /> },
      { label: 'Payout Logic', component: <PayoutLogic /> },
    ],
    []
  );

  return (
    <div className={'min-w-[800px]'}>
      <h1 className={'text-[23px]'}>
        Leeloo Packages | Edit $25,000 Aspire | Investor
      </h1>
      <div className={'mt-4.5'}>
        <Tab
          className={'pb-2 mb-3'}
          tabActive={tabActive}
          tabs={tabs}
          onChangeTab={setTabActive}
        />
      </div>
    </div>
  );
};
